// Filename: views/layout/supervisor.js
define('views/layouts/content/layout-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // custom
    'services/layout',
    'src/queue/delay-queue',
    // views
    'views/layouts/content/layout-info-stack',
    // 'views/layouts/content/layout-info',
    // Templates
    'text!templates/layouts/content/layout-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // custom
    LayoutState,
    DelayQueue,
    // views
    VLayoutInfoStack,
    // VLayoutInfo,
    // Templates
    TLayoutContent
) {

    var VLayoutContent = Backbone.View.extend({
        template: TLayoutContent,
        className: 'layout',
        regions: {
            content: '#page',
            drawer: '#info',
        },

        initialize: function() {
            this.queue = new DelayQueue({ delay: 200, context: this });
            // populated by this controller
            var view = this.view = {
                drawer: new VLayoutInfoStack()
            };

            this.listenTo(LayoutState, {
                'toggle:info': this.toggleInfo,
                'toggle:info:overlay': this.toggleInfoOverlay,
                'toggle:full:info': this.toggleInfoFull,
                'view:info': this.setInfoContent,
            });
        },

        render: function() {
            // this.initListeners();

            // Render Template HTML with Mustache
            this.$el.empty().append(Mustache.render(this.template));

            // get the element related to region selectors
            this.generateZones()
                .renderView(['content', 'drawer']);

            return this;
        },

        /**
         * Info panel
         *
         * The transition takes 0.2s to open/close. In order to
         * limit the toggling between states, custom DelayQueue is used,
         * providing promises.
         */

        /////////////////
        // Toggle info //
        /////////////////

        isInfoToggled: function() {
            var zone = this.zone;
            return zone && zone.$drawer.hasClass('open');
        },

        toggleInfo: function(val) {
            var condition = function() {
                return this.isInfoToggled() !== val;
            };
            return this.queue.add(this._toggleInfo, arguments, {
                    condition: condition
                })
                .done(this._afterInfoToggle);
        },
        _toggleInfo: function(val) {
            if (this.zone) {
                this.zone.$drawer.toggleClass('open', val);
            }
        },
        _afterInfoToggle: function() {
            // trigger an event after as a hook for other views
            // this.isInfoFull()
            LayoutState.setInfoState(this.isInfoToggled());
        },

        //////////////////
        // INFO OVERLAY //
        //////////////////

        toggleInfoOverlay: function(val) {
            return this.view.drawer.toggle(val);
        },

        // INFO CONTENT
        setInfoContent: function(view, options) {
            options = _.extend({
                open: this.isInfoToggled(),
            }, options);
            var open = options.open,
                drawer = this.view.drawer;

            if (open === false) {
                this.toggleInfo(false);
            }

            if (drawer.is(view)) {
                this.toggleInfo(open);
                drawer.toggle(open);
                view.onOpen(open);
            } else {
                drawer.set(view, open).always(function() {
                    this.toggleInfo(open);
                }.bind(this));
            }
        },

        /////////////////
        // Main region //
        /////////////////

        is: function(view) {
            return this.view.content === view;
        },

        getView: function() {
            return this.view.content;
        },

        setView: function(view, render) {
            var viewOb = this.view,
                content = viewOb.content;
            if (!this.is(view)) {
                if (content) content.disable({ defer: true });

                viewOb.content = content = view;
                if (this.zone) this.renderView('content');
            }
        },

        isEmpty: function() {
            return !this.view.content;
        },

        reset: function() {
            this.toggleInfo(false);
        },

    });

    return VLayoutContent;
});

